/** @jsx jsx */
import React from 'react'
import { css, jsx } from '@emotion/react'
import Layout from '../components/Layout'
import ThemeWrapper from '../components/Theme'
import { Column, ColumnWrap, ColumnWrapper, Title, Text, Subtitle, Image, Button, PriceWrap } from '@swp/components'
import SiteHeader from '../components/SiteHeader'

export default function Page(props) {
  return (
    <ThemeWrapper>
      <Layout >
        <SiteHeader set="" currentLanguage={undefined} />

        <Column className="css-usvoga --style2 --full --parallax" name={"uvod"} border={""} parallax={true} fullscreen={true} css={css`
      
    background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/18947/f10ae070cf914f5ea6a65dea1d41d64c_s=350x_.jpg);
    @media (min-width: 351px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/18947/f10ae070cf914f5ea6a65dea1d41d64c_s=660x_.jpg);
    }
    @media (min-width: 661px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/18947/f10ae070cf914f5ea6a65dea1d41d64c_s=860x_.jpg);
    }
    @media (min-width: 861px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/18947/f10ae070cf914f5ea6a65dea1d41d64c_s=1400x_.jpg);
    }
    @media (min-width: 1401px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/18947/f10ae070cf914f5ea6a65dea1d41d64c_s=2000x_.jpg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (max-width: 350px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/18947/f10ae070cf914f5ea6a65dea1d41d64c_s=660x_.jpg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 351px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/18947/f10ae070cf914f5ea6a65dea1d41d64c_s=1400x_.jpg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 861px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/18947/f10ae070cf914f5ea6a65dea1d41d64c_s=3000x_.jpg);
    }
  
    `}>
          
          <ColumnWrap className="--center el--1 flex--center" columns={"1"}>
          </ColumnWrap>

        </Column>


        <Column className="--center pb--60 pl--20 pr--20 pt--60" name={"informace"}>
          
          <ColumnWrap className="column__flex --left el--2 flex--center" columns={"2"}>
            
            <ColumnWrapper className="--left" style={{"maxWidth":514}}>
              
              <Title className="title-box" content={"Restaurace s prémiovou adresou"}>
              </Title>

            </ColumnWrapper>

            <ColumnWrapper style={{"maxWidth":734}}>
              
              <Text className="text-box" content={"<span style=\"color: rgb(0, 0, 0); --darkreader-inline-color:#181a1b;\" data-darkreader-inline-color=\"\">Přijďte ochutnat naši kuchyni a kochejte se unikátním výhledem\nna Národní muzeum třeba u oběda. V letních měsících navíc\nmůžete posedět na zahrádce.\n<br><br>Od pondělí do pátku pro vás připravujeme polední menu,<br>a to v\nčase od 11 do 15 hodin</span><span style=\"color: rgb(0, 0, 0); --darkreader-inline-color:#181a1b;\" data-darkreader-inline-color=\"\"><br></span>"}>
              </Text>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="css-1maqp4y bg--center-h --parallax pb--80 pl--20 pr--20 pt--80" name={"denni-menu"} parallax={true} css={css`
      
    background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/7947/d0fbe6d722cd4bc2b37ef107ed1c04fb_s=350x_.jpg);
    @media (min-width: 351px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/7947/d0fbe6d722cd4bc2b37ef107ed1c04fb_s=660x_.jpg);
    }
    @media (min-width: 661px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/7947/d0fbe6d722cd4bc2b37ef107ed1c04fb_s=860x_.jpg);
    }
    @media (min-width: 861px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/7947/d0fbe6d722cd4bc2b37ef107ed1c04fb_s=1400x_.jpg);
    }
    @media (min-width: 1401px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/7947/d0fbe6d722cd4bc2b37ef107ed1c04fb_s=2000x_.jpg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (max-width: 350px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/7947/d0fbe6d722cd4bc2b37ef107ed1c04fb_s=660x_.jpg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 351px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/7947/d0fbe6d722cd4bc2b37ef107ed1c04fb_s=1400x_.jpg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 861px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/7947/d0fbe6d722cd4bc2b37ef107ed1c04fb_s=3000x_.jpg);
    }
  
    `}>
          
          <ColumnWrap className="column__flex --shape3 --left el--1 flex--top" style={{"maxWidth":""}} columns={"1"}>
            
            <ColumnWrapper >
              
              <Title className="title-box title-box--center pl--0 pr--0" style={{"maxWidth":1525}} content={"<span style='color: white;'>Denní menu<span>"}>
              </Title>

              <Subtitle className="subtitle-box subtitle-box--center mt--0" content={"<span style=\"caret-color: rgb(255, 255, 255); color: rgb(255, 255, 255);\">11.8. - 15.8.</span><br>"}>
              </Subtitle>

            </ColumnWrapper>

          </ColumnWrap>

          <ColumnWrap className="column__flex --shape3 --left el--1 flex--top" style={{"maxWidth":"","backgroundColor":"rgba(255,255,255,1)"}} columns={"1"}>
            
            <ColumnWrapper >
              
              <Text className="text-box" content={"<br>"}>
              </Text>

              <Subtitle className="subtitle-box mt--12" content={"<span style=\"font-weight: bold;\"><br>POLÉVKA K HLAVNÍMU JÍDLU </span>za 49,-<br><br><span style=\"font-weight: bold;\">Pondělí 18.8.</span><br>Hrachová polévka, majoránka a krutóny (1,7)&nbsp; &nbsp;69,-<br>Smažený květák, bramborová kaše, tatarská omáčka (1,3,7)&nbsp; &nbsp;175,-<br>Indické butter chicken, koriandr, jasmínová rýže (7)&nbsp; &nbsp;185,-<br>Hovězí pečeně na česneku, špenát, bramborový knedlík (1,3,7,9)&nbsp; &nbsp;189,-<br>Fazolové chilli s kukuřicí, avokádem a tortillové chipsy&nbsp; &nbsp;189,-<br><br><span style=\"font-weight: bold;\">Úterý 19.8.<br></span>Zeleninový krém, bazalkové pesto (7,8)&nbsp; &nbsp;69,-<br>Kuře na paprice, náš houskový knedlík (1,3,7,9)&nbsp; &nbsp;179,-<br>Těstovinový salát, tuňák, vejce a jogurtový dresink (1,3,4,7,10)&nbsp; &nbsp;185,-<br>Smažený vepřový řízek, lehký salát z brambor s pórkem, citron (1,3,7)&nbsp; &nbsp;189,-<br>Pečené batáty, cizrnový hummus, zeleninový salát s tahini dresinkem&nbsp; &nbsp;185,-<br><br><span style=\"font-weight: bold;\">Středa 20.8.</span><br>Kulajda s vejcem a houbami (1,3,7,9)&nbsp; &nbsp;69,-<br>Lasagne bolognese se sýrovou krustou (1,3,7,9)&nbsp; &nbsp;179,-<br>Pivovarský hovězí guláš, bramboráčky (1,3,7,9)&nbsp; &nbsp;185,-<br>Tortilla plněná kuřecím masem, zelenina, sýr, jogurtový dip, hranolky (1,3,7)&nbsp; &nbsp;195,-<br>Pommodoro s bazalkou, tofu a pečenými lilky, pita chléb (1)&nbsp; &nbsp;185,-<br><br><span style=\"font-weight: bold;\">Čtvrtek 21.8.<br></span>Kuřecí vývar, maso, nudle a zelenina (1,3,9)&nbsp; &nbsp;69,-<br>Zapečené těstoviny s brokolicí, šunkou a sýrem (1,3,7)&nbsp; &nbsp;175,-<br>Grilované kuřecí prso, kuskusový salát s rajčaty a bylinkami (1,7)&nbsp; &nbsp;185,-<br>Hamburská vepřová pečeně, náš houskový knedlík (1,3,7,9,10)&nbsp; &nbsp;189,-<br>Stir-fry zelenina s tempehem, rýžové nudle, sojová omáčka (1,6,11)&nbsp; &nbsp;189,-<br><br><span style=\"font-weight: bold;\">Pátek 22.8.<br></span>Mrkvový krém, zázvor a chilli (7)&nbsp; &nbsp;69,-<br>Penne, rajčatové pesto,  parmezánové hoblinky (1,7,8)&nbsp; &nbsp;179,-<br>Vepřové výpečky, šťouchané brambory s cibulkou (7,9)&nbsp; &nbsp;185,-<br>Treska pečená na bylinkách, zelenina na másle, batátové pyré, citron (1,3,4,7)&nbsp; &nbsp;195,-<br>Krémové kari z červené čočky, mladý špenát, jasmínová rýže&nbsp; &nbsp;185,-<br>"}>
              </Subtitle>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="css-1maqp4y bg--center-h --parallax pb--80 pl--20 pr--20 pt--80" name={"denni-menu"} parallax={true} css={css`
      
    background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/7947/d0fbe6d722cd4bc2b37ef107ed1c04fb_s=350x_.jpg);
    @media (min-width: 351px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/7947/d0fbe6d722cd4bc2b37ef107ed1c04fb_s=660x_.jpg);
    }
    @media (min-width: 661px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/7947/d0fbe6d722cd4bc2b37ef107ed1c04fb_s=860x_.jpg);
    }
    @media (min-width: 861px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/7947/d0fbe6d722cd4bc2b37ef107ed1c04fb_s=1400x_.jpg);
    }
    @media (min-width: 1401px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/7947/d0fbe6d722cd4bc2b37ef107ed1c04fb_s=2000x_.jpg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (max-width: 350px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/7947/d0fbe6d722cd4bc2b37ef107ed1c04fb_s=660x_.jpg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 351px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/7947/d0fbe6d722cd4bc2b37ef107ed1c04fb_s=1400x_.jpg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 861px) {
      background-image: linear-gradient(var(--overlay-color), var(--overlay-color)), url(https://cdn.swbpg.com/t/7947/d0fbe6d722cd4bc2b37ef107ed1c04fb_s=3000x_.jpg);
    }
  
    `}>
          
          <ColumnWrap className="column__flex --shape3 --left el--1 flex--top" style={{"maxWidth":""}} columns={"1"}>
            
            <ColumnWrapper >
              
              <Title className="title-box title-box--center pl--0 pr--0" style={{"maxWidth":1525}} content={"<span style=\"color: white;\">Stálá nabídka jídel<span></span></span>"}>
              </Title>

            </ColumnWrapper>

          </ColumnWrap>

          <ColumnWrap className="column__flex --shape3 --left el--1 flex--top" style={{"maxWidth":"","backgroundColor":"rgba(255,255,255,1)"}} columns={"1"}>
            
            <ColumnWrapper >
              
              <Text className="text-box fs--16 mt--0" content={"<span style=\"font-style: italic;\">Platná vždy od pondělí do neděle.&nbsp;</span><br>"}>
              </Text>

              <Text className="text-box fs--20" content={"<span style=\"color: var(--color-custom-1); --darkreader-inline-color:var(--darkreader-text--color-custom-1); font-weight: bold;\" data-darkreader-inline-color=\"\">Předkrmy a saláty</span>"}>
              </Text>

              <Text className="text-box" content={"<br>"}>
              </Text>

              <Text className="text-box" content={"<span style=\"color: var(--color-custom-1);\">Řecký salát -&nbsp;mix krájené zeleniny, balkánský sýr a octový vinaigrette s oregánem <span style=\"font-weight: bold;\">165 Kč</span></span>"}>
              </Text>

              <Text className="text-box" content={"<span style=\"color: var(--color-custom-1);\">Caesar salát - listy římského salátu, grilované kuřecí prso, parmezán, krutony\na ančovičkový dresink&nbsp;<span style=\"font-weight: bold;\">185 Kč</span></span>"}>
              </Text>

              <Text className="text-box" content={"<br>"}>
              </Text>

              <Text className="text-box fs--20" content={"<span style=\"font-weight: bold;\"><span style=\"color: var(--color-custom-1);\">Hlavní jídla</span>&nbsp;</span>"}>
              </Text>

              <Text className="text-box" content={"<span style=\"color: var(--color-custom-1);\">Omeleta se šunkou od kosti, vařené brambory a míchaný salátek&nbsp;<span style=\"font-weight: bold;\">179 Kč</span></span>"}>
              </Text>

              <Text className="text-box" content={"<span style=\"--darkreader-inline-color:var(--darkreader-text--black); color: var(--color-custom-1);\" data-darkreader-inline-color=\"\">Hovězí svíčková na smetaně, domácí houskový knedlík, brusinky a šlehačka <span style=\"font-weight: bold;\">255 Kč</span></span>"}>
              </Text>

              <Text className="text-box" content={"<span style=\"--darkreader-inline-color:var(--darkreader-text--black); color: var(--color-custom-1);\" data-darkreader-inline-color=\"\">Smažený řízek z kuřecích prsou, vařené brambory a naše tatarská omáčka <span style=\"font-weight: bold;\">199 Kč</span></span>"}>
              </Text>

              <Text className="text-box" content={"<span style=\"--darkreader-inline-color:var(--darkreader-text--black); color: var(--color-custom-1);\" data-darkreader-inline-color=\"\">Smažený sýr, vařené brambory a naše tatarská omáčka <span style=\"font-weight: bold;\">189 Kč</span></span>"}>
              </Text>

              <Text className="text-box" content={"<span style=\"color: var(--color-custom-1);\">Naše tvarohové knedlíky s meruňkami, zakysaná smetana, tvaroh a cukr&nbsp;<span style=\"font-weight: bold;\">169 Kč</span></span>"}>
              </Text>

            </ColumnWrapper>

            <ColumnWrapper >
              
              <Subtitle className="subtitle-box fs--20 mt--12" content={"<span style=\"font-weight: bold; color: rgb(0, 0, 0);\">Pizza</span>"}>
              </Subtitle>

              <Text className="text-box" content={"<span style=\"color: var(--color-custom-1);\">Margherita - rajčatové sugo, mozzarella, bazalka&nbsp;<span style=\"font-weight: bold;\">189 Kč</span></span>"}>
              </Text>

              <Text className="text-box" content={"<span style=\"color: var(--color-custom-1);\">Šunková - rajčatové sugo, šunka od kosti, mozzarella&nbsp;<span style=\"font-weight: bold;\">195 Kč</span></span>"}>
              </Text>

            </ColumnWrapper>

            <ColumnWrapper >
              
              <Subtitle className="subtitle-box fs--20 mt--12" content={"<span style=\"font-weight: bold; color: rgb(0, 0, 0);\">Wrapy</span>"}>
              </Subtitle>

              <Text className="text-box" content={"<span style=\"color: var(--color-custom-1);\">Vegetariánský - mozzarella, rajčata, rukola a bazalkové pesto&nbsp;<span style=\"font-weight: bold;\">159 kč</span></span><br>"}>
              </Text>

              <Text className="text-box" content={"<span style=\"color: var(--color-custom-1);\">Kuřecí - kuřecí nugetky, rajčata, kyselá okurka, cheddar, slanina a andaluský dip&nbsp;<span style=\"font-weight: bold;\">169 kč</span></span><br>"}>
              </Text>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="--left pb--60 pt--60" name={"4ymbv4klm42"}>
          
          <ColumnWrap className="column__flex --center el--2 flex--top" columns={"2"}>
            
            <ColumnWrapper className="--left">
              
              <Subtitle className="subtitle-box" content={"<span style=\"font-weight: bold; color: rgb(0, 0, 0);\">Naše cukrárna</span>"}>
              </Subtitle>

              <Text className="text-box" style={{"maxWidth":650}} content={"<span style=\"color: rgb(0, 0, 0);\">Ochutnejte naše dezerty v bistru nebo si\nje objednejte domů třeba na\nnarozeninovou oslavu. Pravidelně do\nnašeho bistra a kavárny připravujeme\nvěnečky, cheesecaky, sacher dort, koláče,\nale i velmi oblíbený lemon pie.\n<br><br>Pro objednávky dortů nás kontaktujte na\nadrese info@bistronarodnimuzeum.cz</span>"}>
              </Text>

            </ColumnWrapper>

            <ColumnWrapper className="--left">
              
              <Image style={{"maxWidth":546}} src={"https://cdn.swbpg.com/t/18947/4b634212c39547d689618c6dbc9ada7f_s=860x_.jpeg"} sizes="(max-width: 639px) 100vw, (max-width: 1439px) 50vw, 720px" srcSet={"https://cdn.swbpg.com/t/18947/4b634212c39547d689618c6dbc9ada7f_s=350x_.jpeg 350w, https://cdn.swbpg.com/t/18947/4b634212c39547d689618c6dbc9ada7f_s=660x_.jpeg 660w, https://cdn.swbpg.com/t/18947/4b634212c39547d689618c6dbc9ada7f_s=860x_.jpeg 860w, https://cdn.swbpg.com/t/18947/4b634212c39547d689618c6dbc9ada7f_s=1400x_.jpeg 1400w, https://cdn.swbpg.com/t/18947/4b634212c39547d689618c6dbc9ada7f_s=2000x_.jpeg 2000w"}>
              </Image>

            </ColumnWrapper>

          </ColumnWrap>

          <ColumnWrap className="column__flex --center el--2 flex--top" columns={"2"}>
            
            <ColumnWrapper className="--left">
              
              <Image style={{"maxWidth":565}} src={"https://cdn.swbpg.com/t/18947/19cc9ea0fae447bb842aeb44c852bbca_s=860x_.JPG"} sizes="(max-width: 639px) 100vw, (max-width: 1439px) 50vw, 720px" srcSet={"https://cdn.swbpg.com/t/18947/19cc9ea0fae447bb842aeb44c852bbca_s=350x_.JPG 350w, https://cdn.swbpg.com/t/18947/19cc9ea0fae447bb842aeb44c852bbca_s=660x_.JPG 660w, https://cdn.swbpg.com/t/18947/19cc9ea0fae447bb842aeb44c852bbca_s=860x_.JPG 860w, https://cdn.swbpg.com/t/18947/19cc9ea0fae447bb842aeb44c852bbca_s=1400x_.JPG 1400w, https://cdn.swbpg.com/t/18947/19cc9ea0fae447bb842aeb44c852bbca_s=2000x_.JPG 2000w"}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper className="--left">
              
              <Subtitle className="subtitle-box mt--50" content={"<span style=\"color: rgb(0, 0, 0); font-weight: bold;\">Kompletní občerstvení\npro vaše akce</span><br>"}>
              </Subtitle>

              <Text className="text-box" style={{"maxWidth":650}} content={"<span style=\"color: rgb(0, 0, 0);\">Jsme tým profesionálů v oblasti cateringu\ni event managementu.<br>Dle typu akce\npřipravíme pohoštění, které podtrhne vaši\nudálost.<br></span><br>"}>
              </Text>

              <Button className="btn-box btn-box--center mt--0" url={"https://olivacatering.cz/"} href={"https://olivacatering.cz/"} content={"Více info"}>
              </Button>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column name={"izszu0rqcob"} layout={"l8"}>
          
          <ColumnWrap className="column__flex --center el--3 flex--center" columns={"3"}>
            
            <ColumnWrapper >
              
              <Image src={"https://cdn.swbpg.com/t/18947/0c95630bf21b48c5b5f8977212c84f7a_s=660x_.png"} url={"https://bistronarodnimuzeum.cz/"} use={"url"} href={"https://bistronarodnimuzeum.cz/"} sizes="(max-width: 959px) 100vw, (max-width: 1439px) 33vw, 480px" srcSet={"https://cdn.swbpg.com/t/18947/0c95630bf21b48c5b5f8977212c84f7a_s=350x_.png 350w, https://cdn.swbpg.com/t/18947/0c95630bf21b48c5b5f8977212c84f7a_s=660x_.png 660w, https://cdn.swbpg.com/t/18947/0c95630bf21b48c5b5f8977212c84f7a_s=860x_.png 860w"} lightbox={false}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper className="pt--25">
              
              <Image className="pt--06" style={{"maxWidth":219}} src={"https://cdn.swbpg.com/t/18947/92291b2f2f3f4415a5c7aba9c7625ab9_s=660x_.png"} url={"https://oliverscoffeecup.cz/"} use={"url"} href={"https://oliverscoffeecup.cz/"} sizes="(max-width: 959px) 100vw, (max-width: 1439px) 33vw, 480px" srcSet={"https://cdn.swbpg.com/t/18947/92291b2f2f3f4415a5c7aba9c7625ab9_s=350x_.png 350w, https://cdn.swbpg.com/t/18947/92291b2f2f3f4415a5c7aba9c7625ab9_s=660x_.png 660w"} lightbox={false}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper >
              
              <Image src={"https://cdn.swbpg.com/t/18947/1fa2836e19d74ad6b499041d89e1e57f_s=660x_.png"} url={"https://olivacatering.cz/"} use={"url"} href={"https://olivacatering.cz/"} sizes="(max-width: 959px) 100vw, (max-width: 1439px) 33vw, 480px" srcSet={"https://cdn.swbpg.com/t/18947/1fa2836e19d74ad6b499041d89e1e57f_s=350x_.png 350w, https://cdn.swbpg.com/t/18947/1fa2836e19d74ad6b499041d89e1e57f_s=660x_.png 660w, https://cdn.swbpg.com/t/18947/1fa2836e19d74ad6b499041d89e1e57f_s=860x_.png 860w"} lightbox={false}>
              </Image>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="css-gqd6tz pb--60 pt--60" name={"su12u3eyc3"} css={css`
      
    background-image: url(https://cdn.swbpg.com/t/18947/a0a4c310f62a4b09a1229311c43f84b1_s=350x_.jpg);
    @media (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/18947/a0a4c310f62a4b09a1229311c43f84b1_s=660x_.jpg);
    }
    @media (min-width: 661px) {
      background-image: url(https://cdn.swbpg.com/t/18947/a0a4c310f62a4b09a1229311c43f84b1_s=860x_.jpg);
    }
    @media (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/18947/a0a4c310f62a4b09a1229311c43f84b1_s=1400x_.jpg);
    }
    @media (min-width: 1401px) {
      background-image: url(https://cdn.swbpg.com/t/18947/a0a4c310f62a4b09a1229311c43f84b1_s=2000x_.jpg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (max-width: 350px) {
      background-image: url(https://cdn.swbpg.com/t/18947/a0a4c310f62a4b09a1229311c43f84b1_s=660x_.jpg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 351px) {
      background-image: url(https://cdn.swbpg.com/t/18947/a0a4c310f62a4b09a1229311c43f84b1_s=1400x_.jpg);
    }
    @media (-webkit-min-device-pixel-ratio: 2) and (min-width: 861px) {
      background-image: url(https://cdn.swbpg.com/t/18947/a0a4c310f62a4b09a1229311c43f84b1_s=3000x_.jpg);
    }
  
    `}>
          
          <ColumnWrap className="column__flex el--3" columns={"3"}>
            
            <ColumnWrapper >
              
              <PriceWrap className="el--1 flex--stretch" style={{"maxWidth":600,"backgroundColor":"#f4f4f4"}} columns={"1"}>
                
                <ColumnWrapper className="--center">
                  
                  <Text className="text-box ff--2 fs--8 w--500" content={"<br>"}>
                  </Text>

                  <Text className="text-box ff--2 fs--20 w--500" content={"<span style=\"font-weight: bold; color: rgb(0, 0, 0);\">Nová budova Národního muzea</span>"}>
                  </Text>

                  <Text className="text-box fs--18" style={{"maxWidth":392}} content={"<span style=\"font-weight: bold; color: var(--color-custom-1);\">PO - NE</span>"}>
                  </Text>

                  <Text className="text-box fs--18" style={{"maxWidth":392}} content={"<span style=\"color: var(--color-custom-1);\">9:30 - 19:00</span>"}>
                  </Text>

                  <Text className="text-box fs--18" style={{"maxWidth":392}} content={"<br>"}>
                  </Text>

                  <Text className="text-box fs--18" style={{"maxWidth":392}} content={"<span style=\"color: var(--color-custom-1);\">Telefon: +420 257 310 852</span><br>"}>
                  </Text>

                </ColumnWrapper>

              </PriceWrap>

            </ColumnWrapper>

            <ColumnWrapper >
              
              <PriceWrap className="el--1" style={{"maxWidth":600,"backgroundColor":"#f4f4f4"}} columns={"1"}>
                
                <ColumnWrapper >
                  
                  <Text className="text-box text-box--center fs--36" content={"<br>"}>
                  </Text>

                  <Text className="text-box text-box--center fs--18" content={"<span style=\"color: rgb(0, 0, 0);\">Telefonické objednávky<br>od 10:00 do 15:00 na telefonu:<br>+420 257 310 852.</span><br>"}>
                  </Text>

                  <Text className="text-box text-box--center fs--30 mt--12 pt--02" content={"<br>"}>
                  </Text>

                </ColumnWrapper>

              </PriceWrap>

            </ColumnWrapper>

            <ColumnWrapper >
              
              <PriceWrap className="el--1 flex--stretch" style={{"maxWidth":600,"backgroundColor":"#f4f4f4"}} columns={"1"}>
                
                <ColumnWrapper >
                  
                  <Text className="text-box text-box--center fs--8" content={"<br>"}>
                  </Text>

                  <Text className="text-box text-box--center fs--20" content={"<span style=\"font-weight: bold; color: rgb(0, 0, 0);\">Historická budova Národního muzea</span><br>"}>
                  </Text>

                  <Text className="text-box text-box--center fs--18" content={"<span style=\"font-weight: bold; color: var(--color-custom-1);\">PO - NE</span><br>"}>
                  </Text>

                  <Text className="text-box text-box--center fs--18" content={"<span style=\"color: var(--color-custom-1);\">10:00 - 18:00</span><br>"}>
                  </Text>

                  <Text className="text-box fs--18" content={"<br>"}>
                  </Text>

                  <Text className="text-box text-box--center fs--18" content={"<span style=\"color: var(--color-custom-1);\">Telefon: +420 220 960 458</span><br>"}>
                  </Text>

                </ColumnWrapper>

              </PriceWrap>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>


        <Column className="mb--20 pb--60 pl--20 pr--20 pt--60">
          
          <ColumnWrap className="column__flex el--4 pl--0 pr--0 flex--top" columns={"4"}>
            
            <ColumnWrapper className="pl--20 pr--20">
              
              <Image className="--left" style={{"maxWidth":192}} alt={""} src={"https://cdn.swbpg.com/t/18947/ecbb0ce72a4c4111a213e39f1d862127_s=860x_.png"} sizes="(max-width: 639px) 100vw, (max-width: 1279px) 50vw, 350px" srcSet={"https://cdn.swbpg.com/t/18947/ecbb0ce72a4c4111a213e39f1d862127_s=350x_.png 350w, https://cdn.swbpg.com/t/18947/ecbb0ce72a4c4111a213e39f1d862127_s=660x_.png 660w, https://cdn.swbpg.com/t/18947/ecbb0ce72a4c4111a213e39f1d862127_s=860x_.png 860w, https://cdn.swbpg.com/t/18947/ecbb0ce72a4c4111a213e39f1d862127_s=1400x_.png 1400w"}>
              </Image>

              <Image style={{"maxWidth":360}} sizes="(max-width: 639px) 100vw, (max-width: 1279px) 50vw, 350px" srcSet={"https://cdn.swbpg.com/t/18947/f72737ff91454a4eb62da0d06749273a_s=350x_.png 350w, https://cdn.swbpg.com/t/18947/f72737ff91454a4eb62da0d06749273a_s=660x_.png 660w, https://cdn.swbpg.com/t/18947/f72737ff91454a4eb62da0d06749273a_s=860x_.png 860w, https://cdn.swbpg.com/t/18947/f72737ff91454a4eb62da0d06749273a_s=1400x_.png 1400w, https://cdn.swbpg.com/t/18947/f72737ff91454a4eb62da0d06749273a_s=2000x_.png 2000w"} alt={""} src={"https://cdn.swbpg.com/t/18947/f72737ff91454a4eb62da0d06749273a_s=860x_.png"}>
              </Image>

            </ColumnWrapper>

            <ColumnWrapper className="pl--20 pr--20">
              
              <Subtitle className="subtitle-box subtitle-box--center mt--02" style={{"color":"var(--color-variable-1)"}} content={"<span style=\"color: rgb(0, 0, 0);\">E-mail</span>"}>
              </Subtitle>

              <Text className="text-box text-box--center fs--12" style={{"maxWidth":256}} content={"<span style=\"color: var(--color-custom-1);\">info@bistronarodnimuzeum.cz</span>"}>
              </Text>

            </ColumnWrapper>

            <ColumnWrapper className="--center pl--20 pr--20">
              
              <Subtitle className="subtitle-box mt--02" style={{"color":"var(--color-variable-1)"}} content={"<span style=\"color: rgb(0, 0, 0);\">Telefon</span>"}>
              </Subtitle>

              <Text className="text-box fs--12" style={{"maxWidth":256}} content={"<span style=\"color: var(--color-custom-1);\">+420 257 310 852</span>"}>
              </Text>

            </ColumnWrapper>

            <ColumnWrapper className="pl--20 pr--20">
              
              <Subtitle className="subtitle-box subtitle-box--center mt--02" style={{"color":"var(--color-variable-1)"}} content={"<span style=\"color: rgb(0, 0, 0);\">Sledujte nás</span>"}>
              </Subtitle>

              <Text className="text-box text-box--center fs--12" style={{"maxWidth":256}} content={"<a href=\"https://www.facebook.com/bistronarodnimuzeum\" target=\"_blank\">Facebook</a>"}>
              </Text>

              <Text className="text-box text-box--center fs--12" style={{"maxWidth":256}} content={"<a href=\"https://www.instagram.com/bistronarodnimuzeum/\" target=\"_blank\">Instagram</a>"}>
              </Text>

            </ColumnWrapper>

          </ColumnWrap>

        </Column>

      </Layout>
    </ThemeWrapper>
  )
}